import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Generate.css';

const Generate = ({ userData }) => {
    const navigate = useNavigate();

    const handleGenerateVideos = () => {
        const videoUrls = [];
        for (let i = 1; i <= 10; i++) {
            const videoFile = `${userData.gender}-${userData.bodyPart}${i}.mp4`;
            videoUrls.push(`http://localhost:3000/videoPublic/${videoFile}`);
        }

        console.log("Generated Video URLs:", videoUrls);
        navigate('/success', { state: { videoUrls } });
    };

    return (
        <div className="generate-container">
            <h1 className="generate-title">Review Your Data</h1>
            <div className="generate-data">
                <div className="data-row">
                    <div className="data-label">Gender:</div>
                    <div className="data-value">{userData.gender}</div>
                </div>
                <div className="data-row">
                    <div className="data-label">Age:</div>
                    <div className="data-value">{userData.age} years</div>
                </div>
                <div className="data-row">
                    <div className="data-label">Weight:</div>
                    <div className="data-value">{userData.weight} kg</div>
                </div>
                <div className="data-row">
                    <div className="data-label">Height:</div>
                    <div className="data-value">{userData.height} feet</div>
                </div>
                <div className="data-row">
                    <div className="data-label">Fitness Goal:</div>
                    <div className="data-value">{userData.fitnessGoal}</div>
                </div>
                <div className="data-row">
                    <div className="data-label">Experience Level:</div>
                    <div className="data-value">{userData.yourLevel}</div>
                </div>
                <div className="data-row">
                    <div className="data-label">Preferred Body Part:</div>
                    <div className="data-value">{userData.bodyPart}</div>
                </div>
            </div>
            <button className="submit-button" onClick={handleGenerateVideos}>Generate Videos</button>
        </div>
    );
};

export default Generate;
